import { Box } from '@mui/material';
import SideBar from '../SideBar';
import NewSideBar from '../SideBar/NewSideBar';
export default function Layout({ children }) {
  return (
    <Box sx={{ display: 'flex' }}>
      {/* <SideBar /> */}
      <NewSideBar />
      <Box
        component="main"
        sx={{
          width: '100%',
          minWidth: 0,
          pt: { xs: '64px', md: 0 },
          overflowX: 'hidden',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
